import { UriTemplate } from './lib/uri-template';

export { UriTemplate } from './lib/uri-template';
